export default "__VITE_ASSET__CFUn7qia__"